import ReactGA from 'react-ga';
import Amplify, { Hub } from '@aws-amplify/core';
import * as Sentry from '@sentry/browser';
import { CognitoAuth } from 'amazon-cognito-auth-js';
import { CookieStorage } from 'amazon-cognito-identity-js';
import { gapi } from 'gapi-script';
import store from '../redux/store';

const getCookieConfig = (cognito) => {
  return {
    domain: cognito.COOKIE_STORAGE_DOMAIN,
    path: '/', // OPTIONAL - Cookie path
    expires: 7, // OPTIONAL - Cookie expiration in days
    secure: true, // OPTIONAL - Cookie secure flag
  };
};

const amplify = ({ env, cognito }) => {
  const amplifyConfigure = {
    Auth: {
      identityPoolId: cognito.IDENTITY_POOL,
      region: cognito.REGION,
      userPoolId: cognito.USER_POOL,
      userPoolWebClientId: cognito.USER_POOL_CLIENT_ID,
    },
  };

  if (env === 'production') {
    amplifyConfigure.Auth.cookieStorage = getCookieConfig(cognito);
  }

  Amplify.configure(amplifyConfigure);
};

const googleAnalytics = ({ ga }) => {
  if (ga.enabled) {
    ReactGA.initialize(ga.trackingId, { debug: ga.debug });

    let page = window.location.pathname + window.location.search,
      options = {};
    ReactGA.set({
      page,
      location: `${window.location.origin}${page}`,
      ...options,
    });
    ReactGA.pageview(page);
  }
};

const sentry = ({ env }) => {
  if (env === 'staging' || env === 'production') {
    class MyTransport extends Sentry.Transports.BaseTransport {
      captureEvent(event) {
        const { cognitoId } = store.getState().user;

        event.extra = {
          cognitoId: cognitoId,
        };

        return fetch(this.url, {
          body: JSON.stringify(event),
          method: 'POST',
        })
          .then((response) => ({
            status: response.status === '413' ? 'rate_limit' : 'success',
          }))
          .catch((err) => ({ status: 'failed' }));
      }
    }

    Sentry.init({
      dsn: 'https://35efec1a53904f1e9b78a411c5db3c33@sentry.io/1312636',
      environment: env,
      transport: MyTransport,
    });
  }
};

const loadFacebookSdk = ({ cognito }) => {
  if (cognito.FACEBOOK_APP_ID) {
    window.fbAsyncInit = function () {
      const fb = window.FB;
      fb.init({
        appId: cognito.FACEBOOK_APP_ID,
        cookie: true,
        xfbml: true,
        version: 'v2.11',
      });
    };

    const script = document.createElement('script');
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.onload = function () {};
    document.body.appendChild(script);
  }
};

const loadGoogleSdk = ({ cognito }) => {

  if (cognito.GOOGLE_CLIENT_ID) {
    window.gapi.load('client:auth2', () => {
      window.gapi.client.init({
        clientId: cognito.GOOGLE_CLIENT_ID,
        scope: 'profile email openid',
        // ux_mode: 'redirect',
        // redirect_uri: window.location.origin
      })})

    // const script = document.createElement('script');
    // script.src = 'https://apis.google.com/js/platform.js';
    // script.async = true;
    // script.onload = function () {
    //   const ga = window.gapi;
    //   ga.load('auth2', function () {
    //     ga.auth2.init({
    //       client_id: cognito.GOOGLE_CLIENT_ID,
    //       scope: 'profile email openid'
    //     });
    //   });
    // };
    // document.body.appendChild(script);
  }
};

const cognitoAuthHelper = ({ env, cognito, sites }) => {
  let storage = null;

  if (env === 'production') {
    storage = new CookieStorage(getCookieConfig(cognito));
  }

  const authData = {
      ClientId: cognito.USER_POOL_CLIENT_ID,
      UserPoolId: cognito.USER_POOL,
      AppWebDomain: cognito.AMAZON_COGNITO_DOMAIN,
      TokenScopesArray: ['email', 'phone', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      RedirectUriSignIn: sites.kambria,
      RedirectUriSignOut: sites.kambria,
      Storage: storage,
    },
    cognitoAuth = new CognitoAuth(authData);

  cognitoAuth.userhandler = {
    onSuccess: function (result) {
      Hub.dispatch('auth', {
        event: 'returnSession',
        data: result,
      });
    },
    onFailure: function (err) {
      console.error(err);
    },
  };

  window.cognitoAuth = cognitoAuth;
  window.cognito = cognito;
};

export default function init(config) {
  amplify(config);
  googleAnalytics(config);
  sentry(config);
  //loadFacebookSdk(config);
  loadGoogleSdk(config);
  cognitoAuthHelper(config);
};
